export enum TierartEnum {
  HUND = 'Hund',
  KATZE = 'Katze',
  PFERD = 'Pferd',
}
